"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ProductRecentlyViewed_module_1 = tslib_1.__importDefault(require("./modules/ProductRecentlyViewed.module"));
const WishList_module_1 = tslib_1.__importDefault(require("./modules/WishList.module"));
const Compare_module_1 = tslib_1.__importDefault(require("./modules/Compare.module"));
const loadProductRecentlyViewedRootModule = () => ({
    hasRouter: false,
    modules: [(0, Compare_module_1.default)(), (0, ProductRecentlyViewed_module_1.default)(), (0, WishList_module_1.default)()],
});
exports.default = loadProductRecentlyViewedRootModule;
